import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Button } from 'hljd'
import { observer } from 'mobx-react'
import { getMoney } from '@hlj/hlj-utils'
import isNil from 'lodash/isNil'
import style from './index.module.less'
const FormItem = Form.Item

@Form.create()
@observer
export default class extends Component {
  render() {
    const {
      title,
      liveTime,
      image_path,
      vertical_image_path,
      video_path,
      packages,
      cases,
      watching_focus,
      giftOfReservation,
      otherActivity,
      goBack
    } = this.props.store
    return (
      <Form className={style.liveInfo}>
        <div className={style.partTitle}>基本信息</div>
        <FormItem label={'直播主题'}>{title}</FormItem>
        <FormItem label={'直播时间'}>{liveTime}</FormItem>
        <FormItem label={'封面'}>
          {image_path ? (
            <img className={style.mediaImage} src={image_path} />
          ) : null}
          {vertical_image_path ? (
            <img className={style.mediaVImage} src={vertical_image_path} />
          ) : null}
        </FormItem>
        <FormItem key="Video" label={'预热视频'}>
          {video_path ? (
            <video className={style.mediaPlayer} controls src={video_path} />
          ) : null}
        </FormItem>

        <div className={style.partTitle}>直播活动信息</div>
        <FormItem key="packages" label={'关联套餐'}>
          <div className={style.packages}>
            {packages.map(
              ({ title, cover_path, actual_price, activity_price }, i) => (
                <div key={i} className={style.packagesItem}>
                  <img
                    className={style.itemImg}
                    src={`${cover_path}?imageView2/2/w/122`}
                  />
                  <div className={style.itemContent}>
                    <p className={style.itemText}>{title}</p>
                    <p className={style.itemText}>
                      现价：{getMoney(actual_price)}
                    </p>
                    <p className={style.itemText}>
                      活动价：{!isNil(activity_price) &&
                        getMoney(activity_price)}
                    </p>
                  </div>
                </div>
              )
            )}
          </div>
        </FormItem>
        <FormItem key="cases" label={'关联案例'}>
          <div className={style.packages}>
            {cases.map(({ title, cover_path }, i) => (
              <div key={i} className={style.packagesItem}>
                <img
                  className={style.itemImg}
                  src={`${cover_path}?imageView2/2/w/122`}
                />
                <div className={style.itemContent}>
                  <p className={style.itemText}>{title}</p>
                </div>
              </div>
            ))}
          </div>
        </FormItem>
        <FormItem key="watching_focus" label={'直播看点'}>
          {watching_focus.map(focus => (
            <div className={style.imgBox}>
              <img src={focus.photo.cover_path + '?imageView2/2/w/400'} />
            </div>
          ))}
        </FormItem>
        <FormItem key="giftOfReservation" label={'预约礼包'}>
          {giftOfReservation}
        </FormItem>
        <FormItem key="otherActivity" label={'直播抽奖'}>
          {otherActivity}
        </FormItem>
        <div className={style.submit}>
          <Button type="primary" className={style.submitBtn} onClick={goBack}>
            返回
          </Button>
        </div>
      </Form>
    )
  }
}
